import * as React from "react"
import { AfterPage } from "types/afterjs"
import { Paper, ProductLicense, TransactionStatus, Seo } from "components"
import { Transaction } from "types/transaction"
import fetchTransaction from "./action"

interface TransactionPage {
	data: Transaction
}

interface MatchProps {
	id: string
}

const TransactionPage: AfterPage<TransactionPage, MatchProps> = ({ data }) => {
	return (
		<>
			<Seo
				title="پیگیری تراکنش"
				description="پیگیری وضعیت تراکنش و دریافت لایسنس آنتی ویروس"
				path={`/transaction/${data.ref_id}`}
			/>
			<Paper className="p-3 d-flex flex-column justify-content-right align-items-right">
				<TransactionStatus {...data} />
				<ProductLicense license={data.license || []} />
			</Paper>
		</>
	)
}

TransactionPage.getInitialProps = async ({ match }) => {
	const { id } = match.params
	try {
		const { data } = await fetchTransaction(id)
		return { data }
	} catch (error) {
		return { error }
	}
}

export default TransactionPage
